/**
 * Created by huzhongchun on 2018/4/26.
 */

//project_label
export const PROJECT_LABEL = 'MILLIONAIRE';

//route base path
export const PRODUCT_ROUTE_BASE_PATH = '/chicken/page/entrance';
export const DEVELOPMENT_ROUTE_BASE_PATH = '';

//api host
export const API_ONLINE_HOST = window.location.protocol+'//milapi.taooo.cc';

//get token
export const GET_TOKEN_URL = '/mall/page/get_token';
export const GET_TOKEN_REQUEST_BASEURL = window.location.origin;
export const GET_TOKEN_REQUEST_TYPE = 'mall';

function getRouteBaseUrl () {
	if(process.env.NODE_ENV === 'development'){
		return DEVELOPMENT_ROUTE_BASE_PATH;
	}else{
		return PRODUCT_ROUTE_BASE_PATH;
	}
}

export const tabBar = [
	{
		path: getRouteBaseUrl()+'/',
		root: true,
		text: '今日阅读',
		icon:'',
		activeIcon:''
	},
	{
		path: getRouteBaseUrl()+'/user_center',
		text: '我的',
		icon:'',
		activeIcon:''
	},
];


export default {
	PRODUCT_ROUTE_BASE_PATH,
	DEVELOPMENT_ROUTE_BASE_PATH,
	API_ONLINE_HOST,
	GET_TOKEN_URL,
	tabBar
};



// WEBPACK FOOTER //
// ./src/config/configMillionaire.js